var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5336_38314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5335 1.11234C12.4718 1.02585 12.3902 0.955364 12.2957 0.906774C12.2012 0.858183 12.0964 0.832892 11.9902 0.833008H4.01016C3.90389 0.832892 3.79913 0.858183 3.70462 0.906774C3.6101 0.955364 3.52857 1.02585 3.46683 1.11234L0.457496 5.32567C0.376828 5.43872 0.333477 5.57413 0.333496 5.71301V15.4997C0.333496 15.6765 0.403734 15.8461 0.528758 15.9711C0.653783 16.0961 0.823352 16.1663 1.00016 16.1663H15.0002C15.177 16.1663 15.3465 16.0961 15.4716 15.9711C15.5966 15.8461 15.6668 15.6765 15.6668 15.4997V5.71301C15.6668 5.57413 15.6235 5.43872 15.5428 5.32567L12.5335 1.11234Z",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.833008V5.49967",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 12.167H8.66732C8.48322 12.167 8.33398 12.3162 8.33398 12.5003V13.8337C8.33398 14.0178 8.48322 14.167 8.66732 14.167H13.334C13.5181 14.167 13.6673 14.0178 13.6673 13.8337V12.5003C13.6673 12.3162 13.5181 12.167 13.334 12.167Z",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.368652 5.5H15.6313",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5336_38314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.c47404eef9da66a955a6b8fde82a77ea.svg";
export { ForwardRef as ReactComponent };